import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchShowDoctors = createAsyncThunk(
    'doctors/showDoctors',
    async ({id,team}, { rejectWithValue }) => {
        try {

            const response = await api.get(`/doctors/show/${id}/${team}`)
            return response.data.data;
        } catch (error) {
            console.error("API Error:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


const showDoctorsSlice = createSlice({
    name: "showDoctors",
    initialState: {
        loading: false,
        error: null,
        doctors: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowDoctors.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchShowDoctors.fulfilled, (state, action) => {
                state.loading = false;
                state.doctors = action.payload;
            })
            .addCase(fetchShowDoctors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default showDoctorsSlice.reducer;